<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商城管理</el-breadcrumb-item>
        <el-breadcrumb-item>申请售后</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form
        ref="listForm"
        :model="listParams"
        label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="售后状态：" prop="serviceStatus">
              <el-select
                placeholder="请选择订单状态"
                size="small"
                v-model="listParams.serviceStatus"
                style="width: 100%;"
                clearable>
                <el-option
                  v-for="item in serviceStatusList"
                  :label="item.title"
                  :value="item.id"
                  :key="item.title">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="日期查询：" prop="timeInterval">
              <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="用户账号：" prop="userAccount">
              <el-input
                size="small"
                v-model="listParams.userAccount"
                placeholder="请输入用户账号">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="用户手机号：" prop="phoneNumber">
              <el-input
                size="small"
                v-model="listParams.phoneNumber"
                placeholder="请输入用户手机号">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button
                size="small"
                type="primary"
                @click="loadTableData">
                查询
              </el-button>

              <el-button
                size="small"
                @click="resetFields('listForm')">
                重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange">

      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table
        slot="content"
        :data="tableData"
        max-height="800"
        border>
        <el-table-column
          width="80"
          align="center"
          label="序号">
          <template slot-scope="scope">
            <span
              v-text="(pager.pageIndex > 1 ?
               (pager.pageIndex-1) * pager.pageSize :
               0) + scope.$index + 1">
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="goodsName"
          align="center"
          label="申请售后商品">
        </el-table-column>

        <el-table-column
          width="200"
          prop="orderDate"
          align="center"
          label="下单日期">
          <template slot-scope="scope">
            {{ scope.row.orderDate | formatDate }}
          </template>
        </el-table-column>

        <el-table-column
          width="200"
          prop="serviceDate"
          align="center"
          label="申请日期">
          <template slot-scope="scope">
            {{ scope.row.serviceDate | formatDate }}
          </template>
        </el-table-column>

        <el-table-column
          width="120"
          prop="goodsPictures"
          align="center"
          label="商品图片">
          <template slot-scope="scope">
            <div style="display: flex;">
              <div
                class="thumbnail-img mgl10">
                <img :src="scope.row.goodsPictures" alt="">
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="200"
          prop="serviceReason"
          align="center"
          label="申请原因">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.serviceReason" placement="top">
              <el-button type="text">{{ scope.row.serviceReason | formatLimitLength }}</el-button>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column
          prop="serviceStatusDisplay"
          align="center"
          label="售后状态">
        </el-table-column>

        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <confirm-button
              v-if="scope.row.serviceStatusValue === 1"
              type="text"
              style="margin: 0 10px;"
              title="确认要同意申请吗？"
              @confirmed="applyService(scope.row.serviceId)">
              同意申请
            </confirm-button>

            <el-button
              v-if="scope.row.serviceStatusValue === 1"
              type="text"
              @click="openDialog(scope.row.serviceId)">
              拒绝申请
            </el-button>

            <confirm-button
              v-if="scope.row.serviceStatusValue === 2"
              type="text"
              style="margin: 0 10px;"
              title="确认要退款吗？"
              @confirmed="refundItem(scope.row.serviceId)">
              退款
            </confirm-button>

            <el-button
              type="text"
              @click="linkToDetailPage(scope.row.serviceId)">
              申请详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog
      class="hx-to-create-template"
      title="拒绝申请"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false">
      <el-form
        ref="dialogForm"
        :rules="checkItemParams"
        :model="itemParams"
        label-width="120px">
        <el-form-item label="拒绝理由 ：" prop="rejectReason">
          <el-input
            type="textarea"
            :rows="4"
            :maxlength="200"
            v-model="itemParams.rejectReason"
            size="small"
            placeholder="请输入拒绝理由(限200字)">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            :disabled="isDisabled"
            size="small"
            type="primary"
            @click="rejectService('dialogForm')">
            确 定
          </el-button>

          <el-button
            size="small"
            @click="cancelReject">
            取 消
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  data () {
    return {
      listParams: {
        serviceStatus: '',
        timeInterval: ['', ''],
        userAccount: '',
        phoneNumber: ''
      },
      serviceStatusList: [
        { id: 1, title: '申请中' },
        { id: 2, title: '同意申请' },
        { id: 3, title: '拒绝申请' },
        { id: 4, title: '退款中' },
        { id: 5, title: '已完成' }
      ],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      isDisabled: false,
      serviceId: '',
      itemParams: {
        rejectReason: ''
      },
      checkItemParams: {
        rejectReason: [
          { required: true, message: '请输入拒绝理由(限200字)', trigger: 'blur' }
        ]
      },
      oldBodyParams: {},
      pagerChanged: false
    };
  },
  mounted () {
    this.loadTableData();
  },
  methods: {
    /**
       * 加载table列表
       */
    loadTableData () {
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      });
      bodyParams.startDate = bodyParams.timeInterval[0];
      bodyParams.endDate = bodyParams.timeInterval[1];
      delete bodyParams.timeInterval;
      const flag = this.checkParamsIsNotChanged(bodyParams, this.oldBodyParams);
      if (!flag) {
        bodyParams.pageIndex = 1;
        this.pager.pageIndex = 1;
      } else {
        bodyParams.pageIndex = this.pager.pageIndex;
      }
      if (this.pagerChanged) {
        bodyParams.pageIndex = this.pager.pageIndex;
      }
      Vue.ajaxGet(this, global.apiUrl + '/mall/list', bodyParams, 'tableLoading').then((res) => {
        this.tableData = res.dataList;
        this.pager.total = res.total;
        this.oldBodyParams = bodyParams;
      });
    },
    /**
       * 重置表单
       * @param name
       */
    resetFields (name) {
      this.$refs[name].resetFields();
    },
    /**
       * pageIndex的change事件
       * @param val
       */
    handleCurrentChange (val) {
      this.pager.pageIndex = val;
      this.pagerChanged = true;
      this.loadTableData();
    },
    /**
       * pageSize的change事件
       * @param val
       */
    handleSizeChange (val) {
      this.pager.pageSize = val;
      this.pagerChanged = true;
      this.loadTableData();
    },
    /**
       * 同意申请
       * @param serviceId
       */
    applyService (serviceId) {
      Vue.ajaxPost(this, global.apiUrl + '/mall/passApply', { serviceId: serviceId }).then((res) => {
        this.$message.success(res.info);
        this.loadTableData();
      });
    },
    /**
       * 打开对话框
       * @param serviceId
       */
    openDialog (serviceId) {
      this.serviceId = serviceId;
      this.dialogVisible = true;
    },
    /**
       * 拒绝申请
       * @param name
       */
    rejectService (name) {
      this.isDisabled = true;
      this.$refs[name].validate((valid) => {
        if (valid) {
          const bodyParams = Object.assign({}, {
            serviceId: this.serviceId,
            rejectReason: this.itemParams.rejectReason
          });
          this.isDisabled = false;
          Vue.ajaxPost(this, global.apiUrl + '/mall/refuseApply', bodyParams).then((res) => {
            this.$message.success(res.info);
            this.dialogVisible = false;
            this.loadTableData();
          });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
       * 关闭对话框
       */
    cancelReject () {
      this.dialogVisible = false;
      this.itemParams.rejectReason = '';
    },
    /**
       * 退款
       * @param serviceId
       */
    refundItem (serviceId) {
      Vue.ajaxPost(this, global.apiUrl + '/mall/refund', { serviceId: serviceId }).then((res) => {
        this.$message.success(res.info);
        this.loadTableData();
      });
    },
    /**
       * 跳转至详情页
       * @param serviceId
       */
    linkToDetailPage (serviceId) {
      this.$router.push({
        name: 'serviceDetail',
        query: {
          serviceId: serviceId
        }
      });
    },
    /**
       * 检测表单参数是否改变
       * @param val
       * @param oldVal
       * @returns {boolean}
       */
    checkParamsIsNotChanged (val, oldVal) {
      if (!this.checkIsEmptyObj(oldVal)) {
        for (const i in val) {
          if (i !== 'pageIndex' && i !== 'pageSize') {
            if (val[i] !== oldVal[i]) {
              return false;
            }
          }
        }
        return true;
      } else {
        return true;
      }
    },
    /**
       * 检测是否为空对象
       * @param obj
       * @returns {boolean}
       */
    checkIsEmptyObj (obj) {
      for (const i in obj) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="less" scoped>
  .home-container {
    .alert-text {
      color: #E9A021;
      cursor: default;
    }
    .thumbnail-img{
      width: 80px;
      height: 80px;
      position: relative;
      img{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
</style>
